import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import Patient from '../pages/patient';

export function Patients() {
  return (
    <Routes>
        <Route path='/' element={<Index child={<Patient />}/>} />
    </Routes>
  );
}
